// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__2Ybwf","title":"ClientCherryInfo_title__2W8jr","itemText":"ClientCherryInfo_itemText__n8_gH"};